import React, { useEffect, useState, useContext, useRef } from "react"
import { CancelTokenSource } from "axios";
import { AuthContext, IWechat, ITwitter, IInstagram } from "../../lib/auth";
import * as apigw from "../../lib/apigw";
import { IPost, listPost, listTwitterPost, ITwitterData, ITwitterMedia, createPost, getUploadUrl, putFile, getFile, listInstagramPost, IInstagramrData } from "../../lib/post";
import { Card, Spinner, Button, Container, Row } from "react-bootstrap";
import FormModal from "./form_modal";
import { BsInstagram, BsFillChatFill, BsCheckSquareFill, BsPencilSquare } from 'react-icons/bs';
 




export default (props: any) => {
    const auth = useContext(AuthContext);
    const [cancelTokenSource] = useState<CancelTokenSource>(apigw.getCancelTokenSource());
    const [isWechatLoaded, setIsWechatLoaded] = useState<boolean>(true);
    const [isTwitterLoaded, setIsTwitterLoaded] = useState<boolean>(true);
    const [isInstagramLoaded, setIsInstagramLoaded] = useState<boolean>(true);
    const [moreWechatLoaded, setMoreWechatLoaded] = useState<boolean>(true);
    const [moreTwitterLoaded, setMoreTwitterLoaded] = useState<boolean>(true);
    const [moreInstagramLoaded, setMoreInstagramLoaded] = useState<boolean>(true);
    const [posts, setPosts] = useState<IPost[]>();
    const [twitterDatas, setTwitterDatas] = useState<ITwitterData[]>();
    const [twitterMedia, setTwitterMedia] = useState<ITwitterMedia[]>();
    const [instagramDatas, setInstagramDatas] = useState<IInstagramrData[]>();
    const [formModalShow, setFormModalShow] = useState(false);
    const [modalType, setModalType] = useState<string>("");
    const [targetPost, setTargetPost] = useState<string>("");
    const [wechatState, setWechatState] = useState<IWechat>();
    const [wechatLastPostId, setWechatLastPostId] = useState<string>("");
    const [twitterState, setTwitterState] = useState<ITwitter>();
    const [twitterNextToken, setTwitterNextToken] = useState<string>("");
    const [instagramState, setInstagramState] = useState<IInstagram>();
    const [instagramNextToken, setInstagramNextToken] = useState<string>("");

    const didInitRef = useRef<boolean>(false);

    useEffect(() => {
        if (didInitRef.current) return;
        if (auth?.isAuthenticated) {
            didInitRef.current = true;
            handleGetWechatToken();
            handleGetTwitterToken();
            handleGetInstagramToken();
            handleGetPosts();
        }
        return () => cancelTokenSource.cancel("Component unmounted, request is cancelled.")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [auth?.isAuthenticated]);

    const handleGetWechatToken = async () => {
        setIsWechatLoaded(true);
        try {
            const json = await auth.getWechat({ cancelToken: cancelTokenSource.token });
            setWechatState(json.data);
        } catch (err) {
            console.log(err);
        }
        setIsWechatLoaded(false);
    }

    const handleGetTwitterToken = async () => {
        setIsTwitterLoaded(true);
        try {
            const json = await auth.getTwitter({ cancelToken: cancelTokenSource.token });
            setTwitterState(json.data);
            handleGetTwitterPosts(true);
        } catch (err) {
            console.log(err);
        }
        setIsTwitterLoaded(false);
    }

    const handleGetInstagramToken = async () => {
        setIsInstagramLoaded(true);
        try {
            const json = await auth.getInstagram({ cancelToken: cancelTokenSource.token });
            setInstagramState(json.data);
            handleGetInstagramPosts();
        } catch (err) {
            console.log(err);
        }
        setIsInstagramLoaded(false);
    }

    const handleGetPosts = async (defaultFlg?: boolean) => {
        setMoreWechatLoaded(true);
        try {
            let posts_json;
            if (defaultFlg) {
                posts_json = await listPost();
                setPosts(posts_json?.data);
            } else {
                posts_json = await listPost(wechatLastPostId, { cancelToken: cancelTokenSource.token });
                if (posts_json?.data) {
                    if (posts) {
                        setPosts([
                            ...posts,
                            ...posts_json?.data,
                        ]);
                    } else {
                        setPosts(posts_json?.data);
                    }
                }
            }
            if (posts_json?.data?.[9] && posts_json?.data?.[9]?.id && posts_json?.data?.[9]?.next_id) {
                setWechatLastPostId(posts_json?.data?.[9]?.id);
            } else {
                setWechatLastPostId("");
            }
        } catch (err) {
            console.log(err);
        }
        setMoreWechatLoaded(false);
    }

    const handleGetTwitterPosts = async (useCache?: boolean) => {
        setMoreTwitterLoaded(true);
        try {
            if (useCache) {
                const cacheAtStr = localStorage.getItem("twitterCacheAt");
                const cacheAt = cacheAtStr ? parseInt(cacheAtStr, 10) : 0;
                const fifteenMinMs = 15 * 60 * 1000;
                if (cacheAt && Date.now() - cacheAt < fifteenMinMs) {
                    const cachedData = localStorage.getItem("twitterCacheData");
                    const cachedMedia = localStorage.getItem("twitterCacheMedia");
                    const cachedNextToken = localStorage.getItem("twitterCacheNextToken") || "";
                    if (cachedData) setTwitterDatas(JSON.parse(cachedData));
                    if (cachedMedia) setTwitterMedia(JSON.parse(cachedMedia));
                    setTwitterNextToken(cachedNextToken);
                    setMoreTwitterLoaded(false);
                    return;
                }
            }
            const twitter_posts_json = await listTwitterPost(twitterNextToken, { cancelToken: cancelTokenSource.token });
            console.log("twitter_posts_json", twitter_posts_json);
            console.log("twitter data", twitter_posts_json?.data?.data);
            console.log("twitter includes media", twitter_posts_json?.data?.includes?.media);
            console.log("twitter meta", twitter_posts_json?.data?.meta);
            if (twitter_posts_json?.data?.data) {
                twitter_posts_json?.data?.data?.forEach((data: ITwitterData) => {
                    if (data.text) {
                        data.text = data.text.split("https://t.co/")?.[0];
                    }
                });
                if (twitterDatas) {
                    setTwitterDatas([
                        ...twitterDatas,
                        ...twitter_posts_json?.data?.data,
                    ]);
                } else {
                    setTwitterDatas(twitter_posts_json?.data?.data);
                }
            }
            if (twitter_posts_json?.data.includes?.media) {
                if (twitterMedia) {
                    setTwitterMedia([
                        ...twitterMedia,
                        ...twitter_posts_json?.data.includes?.media,
                    ]);
                } else {
                    setTwitterMedia(twitter_posts_json?.data.includes?.media);
                }
            }
            setTwitterNextToken(twitter_posts_json?.data.meta?.next_token || "");
            // 初回取得時はキャッシュ保存
            if (useCache) {
                try {
                    localStorage.setItem("twitterCacheData", JSON.stringify(twitter_posts_json?.data?.data || []));
                    localStorage.setItem("twitterCacheMedia", JSON.stringify(twitter_posts_json?.data?.includes?.media || []));
                    localStorage.setItem("twitterCacheNextToken", twitter_posts_json?.data?.meta?.next_token || "");
                    localStorage.setItem("twitterCacheAt", String(Date.now()));
                } catch (e) {
                    console.log(e);
                }
            }
        } catch (err) {
            console.log(err);
        }
        setMoreTwitterLoaded(false);
    }

    const handleGetInstagramPosts = async () => {
        setMoreInstagramLoaded(true);
        try {
            const instagram_posts_json = await listInstagramPost(instagramNextToken, { cancelToken: cancelTokenSource.token });
            if (instagram_posts_json?.data?.data) {
                if (instagramDatas) {
                    setInstagramDatas([
                        ...instagramDatas,
                        ...instagram_posts_json?.data?.data,
                    ]);
                } else {
                    setInstagramDatas(instagram_posts_json?.data?.data);
                }
            }
            setInstagramNextToken(instagram_posts_json?.data?.paging?.next || "");
        } catch (err) {
            console.log(err);
        }
        setMoreInstagramLoaded(false);
    }

    const handleNew = (e: any) => {
        setModalType("create");
        setFormModalShow(true);
    }

    const handleSend = (e: any) => {
        setTargetPost(e.currentTarget.dataset.id)
        setModalType("send");
        setFormModalShow(true);
    }

    const handleUpdate = (e: any) => {
        setTargetPost(e.currentTarget.dataset.id)
        setModalType("update");
        setFormModalShow(true);
    }

    const handleDel = (e: any) => {
        setTargetPost(e.currentTarget.dataset.id)
        setModalType("delete");
        setFormModalShow(true);
    }

    const handleWechatrNext = (e: any) => {
        handleGetPosts();
    }

    const handleTwitterNext = (e: any) => {
        handleGetTwitterPosts(false);
    }

    const handleInstagramNext = (e: any) => {
        handleGetInstagramPosts();
    }

    const handleTwitterWechat = async (e: any) => {
        const targetData = twitterDatas?.find((data: ITwitterData) => {
            return data.id === e.currentTarget.dataset.id
        });
        const targetMedia = twitterMedia?.find((media: ITwitterMedia) => {
            return media.type === "photo" && media.media_key === targetData?.attachments?.media_keys?.[0]
        });
        let mediaUrl = "";
        if (targetMedia?.url) {
            mediaUrl = await fileUploadFromPath(targetMedia?.url);
        }
        if (targetData?.text || mediaUrl) {
            try {
                await createPost(targetData?.text, mediaUrl);
                handleGetPosts(true);
            } catch (err) {
                console.log(err);
            }
        }
    }

    const handleInstagramWechat = async (e: any) => {
        const targetData = instagramDatas?.find((data: IInstagramrData) => {
            return data.id === e.currentTarget.dataset.id
        });
        let mediaUrl = "";
        if (targetData?.media_url) {
            mediaUrl = await fileUploadFromPath(targetData?.media_url);
        }
        if (targetData?.caption || mediaUrl) {
            try {
                await createPost(targetData?.caption, mediaUrl);
                handleGetPosts(true);
            } catch (err) {
                console.log(err);
            }
        }
        console.log(targetData);
    }

    const fileUploadFromPath = async (filePath: string) => {
        try {
            const file = await getFile(filePath);
            const fileName = filePath?.match(".+/(.+?)([?#;].*)?$")?.[1];
            const fileType = file.headers["content-type"];
            // file.nameに後で分割予定の要素名が設定されていたら、あらかじめ_に変換しておく
            let filename = fileName?.replace("?Content-Type=", "_");
            if (filename?.endsWith('.webp')) {
                filename = filename.replace('.webp', '.jpg')
            }
            const filebuffer = Buffer.from(file.data);
            if (filename) {
                const put_json = await getUploadUrl(filename, fileType);
                if (put_json) {
                    const url = put_json?.data;
                    await putFile(url, filebuffer);
                    return url.split("?Content-Type=")?.[0]
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    return (
        <>
            <div className="p-2 m-w-1000">
                <FormModal
                    handleGetPosts={handleGetPosts}
                    targetPost={targetPost}
                    modalType={modalType}
                    show={formModalShow}
                    handleGetWechatToken={handleGetWechatToken}
                    handleGetTwitterToken={handleGetTwitterToken}
                    handleGetInstagramToken={handleGetInstagramToken}
                    onHide={() => setFormModalShow(false)}
                />

                <h2 className="h3 mt-3 d-flex align-items-center"><BsCheckSquareFill className="mr-2" />連携</h2>
                <hr />
                <Container fluid>
                    <div className="row">
                        <div className="col-xl-4 px-1 pb-3">
                            <Wechat
                                wechatState={wechatState}
                                setModalType={setModalType}
                                setFormModalShow={setFormModalShow}
                            />
                        </div>
                        <div className="col-xl-4 px-1 pb-3">
                            <Twitter
                                twitterState={twitterState}
                                setModalType={setModalType}
                                setFormModalShow={setFormModalShow}
                            />
                        </div>
                        <div className="col-xl-4 px-1 pb-3">
                            <Instagram
                                instagramState={instagramState}
                                setModalType={setModalType}
                                setFormModalShow={setFormModalShow}
                            />
                        </div>
                    </div>
                </ Container>

                <h2 className="h3 mt-3 d-flex align-items-center"><BsPencilSquare className="mr-2" />投稿</h2>
                <hr />
                <Container fluid>
                    <Row>
                        <div className="col-xl-4 px-1 pb-3">
                            <Row className="m-0">
                                <div className="wechat col-1 p-1">
                                </div>
                                <div className="border col-11 rounded-right">
                                    <div className="">
                                        <h3 className="d-flex align-items-center mt-3 mb-0"><BsFillChatFill className="mr-2" />WeChat <Button onClick={handleNew} variant="success" className="ml-3 mb-0 btn-sm align-right">新規作成</Button></h3>
                                    </div>
                                    <hr />
                                    {isWechatLoaded && <div className="w-100 text-center">
                                        <Spinner animation="border" variant="info" />
                                    </div>
                                    }
                                    {!isWechatLoaded && <>
                                        {!wechatState && <div className="alert alert-danger text-danger p-2 mx-2">
                                            下記のいずれかの理由で連携されていません<br />
                                            ・規定時間内でのWechatへのリクエスト回数を超過した<br />
                                            ・アプリIDとアクセスキーが設定されていない<br />
                                            ・アプリIDとアクセスキーが正しくない<br />
                                            下書きを残すことは可能です
                                        </div>}
                                        <p className="p-2">
                                            画像付きテキスト(300文字まで)のみ投稿可能。また一日の投稿数に制限があります。
                                        </p>
                                        <div className="m-h-1000 px-2">
                                            {posts?.map((post: IPost, index: number) => {
                                                return (
                                                    <div key={`post-${index}`}>
                                                        <Card className="w-100 mb-3">
                                                            <Card.Header>
                                                                {post.status && +post.status === 1 && <span className="text-danger">下書き</span>}
                                                                {post.status && +post.status === 2 && <span className="text-info">投稿済</span>}
                                                            </Card.Header>
                                                            <Card.Body>
                                                                <div>
                                                                    {post.media && <img src={post.media} className="w-100" alt="Media" />}
                                                                </div>
                                                                <div className="px-1 my-2">
                                                                    {post.text}
                                                                </div>
                                                                <div className="small font-italic text-right">
                                                                    <div>
                                                                        作成日：{post.create_date}
                                                                    </div>
                                                                    <div>
                                                                        更新日：{post.update_date}
                                                                    </div>
                                                                </div>
                                                                <hr className="my-2" />
                                                                <div>
                                                                    {wechatState && post.status && +post.status === 1 &&
                                                                        <Button onClick={handleSend} data-id={post.id} className="m-1 btn-sm">
                                                                            <span>Wechatへ投稿</span>
                                                                        </Button>
                                                                    }
                                                                    {wechatState && post.status && +post.status === 2 &&
                                                                        <Button onClick={handleSend} data-id={post.id} className="m-1 btn-sm btn-info">
                                                                            <span>Wechatへ再投稿</span>
                                                                        </Button>
                                                                    }
                                                                    {post.status && +post.status === 1 &&
                                                                        <Button onClick={handleUpdate} data-id={post.id} className="m-1 btn-sm">
                                                                            <span>更新</span>
                                                                        </Button>
                                                                    }
                                                                    <Button onClick={handleDel} data-id={post.id} className="m-1 btn-sm">
                                                                        <span>削除</span>
                                                                    </Button>
                                                                </div>
                                                            </Card.Body>
                                                        </Card>
                                                    </div>
                                                )
                                            })}
                                            {moreWechatLoaded && <div className="w-100 text-center">
                                                <Spinner animation="border" variant="info" />
                                            </div>}
                                            {!moreWechatLoaded && <>
                                                {wechatLastPostId && <div><Button onClick={handleWechatrNext}>
                                                    <span>Next</span>
                                                </Button></div>}
                                            </>}
                                        </div>
                                    </>}
                                </div>
                            </Row>
                        </div>
                        <div className="col-xl-4 px-1 pb-3">
                            <Row className="m-0">
                                <div className="twitter col-1 p-1">
                                </div>
                                <div className="border col-11 rounded-right">
                                    <div className="">
                                        <h3 className="d-flex align-items-center mt-3 mb-0">X(Twitter)</h3>
                                    </div>
                                    <hr />

                                    {isTwitterLoaded && <div className="w-100 text-center">
                                        <Spinner animation="border" variant="primary" />
                                    </div>}
                                    {!isTwitterLoaded && <>
                                        {!twitterState && <div className="text-danger text-small alert-danger p-2 mb-2">
                                            下記のいずれかの理由で連携されていません<br />
                                            ・規定時間内でのTwitterへのリクエスト回数を超過した<br />
                                            ・TwitterのアプリIDが設定されていない<br />
                                            ・TwitterのアプリIDが正しくない<br />
                                        </div>}
                                        {twitterState && <>
                                            <p className="p-2">
                                                画像は最初の一枚のみWechatに追加可能です。Videoなどの情報は表示されません
                                            </p>
                                            <div className="m-h-1000">
                                                {twitterDatas?.map((twitterData: ITwitterData, index: number) => {
                                                    return (
                                                        <div key={`twitterPost-${index}`}>
                                                            <Card className="w-100 mb-3">
                                                                <Card.Body>
                                                                    <div>
                                                                        {twitterData?.attachments?.media_keys?.map((media_key: string, index: number) => {
                                                                            return (
                                                                                <div key={`twitterPost-media-${index}`}>
                                                                                    {twitterMedia?.filter((media: ITwitterMedia, index: number) => {
                                                                                        return media.type === "photo" && media.media_key === media_key
                                                                                    })
                                                                                        .map((media: ITwitterMedia, index: number) => {
                                                                                            return (
                                                                                                <div key={`twitterPost-media-photo-${index}`}>
                                                                                                    {media.url && <img src={media.url} className="w-100" alt="Media" />}
                                                                                                </div>
                                                                                            )
                                                                                        })}
                                                                                </div>
                                                                            )
                                                                        })}
                                                                    </div>
                                                                    <div className="px-1 my-2">
                                                                        {twitterData.text}
                                                                    </div>
                                                                    <hr />
                                                                    <div>
                                                                        <Button onClick={handleTwitterWechat} data-id={twitterData.id} className="m-1 btn-sm">
                                                                            <span>←Wechatに追加</span>
                                                                        </Button>
                                                                    </div>
                                                                </Card.Body>
                                                            </Card>
                                                        </div>
                                                    )
                                                })}
                                                {moreTwitterLoaded && <div className="w-100 text-center">
                                                    <Spinner animation="border" variant="primary" />
                                                </div>}
                                                {!moreTwitterLoaded && <>
                                                    {twitterNextToken && <div><Button onClick={handleTwitterNext}>
                                                        <span>Next</span>
                                                    </Button></div>}
                                                </>}
                                            </div>
                                        </>}
                                    </>}
                                </div>
                            </Row>
                        </div>
                        <div className="col-xl-4 px-1 pb-3">
                            <Row className="m-0">
                                <div className="instagram col-1 p-1">
                                </div>
                                <div className="border col-11 rounded-right">
                                    <div className="">
                                        <h3 className="d-flex align-items-center mt-3 mb-0"><BsInstagram className="mr-2" />Instagram</h3>
                                    </div>
                                    <hr />
                                    {isInstagramLoaded && <div className="w-100 text-center">
                                        <Spinner animation="border" variant="danger" />
                                    </div>}
                                    {!isInstagramLoaded && <>
                                        {!instagramState && <div className="text-danger text-small alert-danger p-2 mb-2">
                                            下記のいずれかの理由で連携されていません<br />
                                            ・規定時間内でのInstagramへのリクエスト回数を超過した<br />
                                            ・Instagram IDとアクセストークンが設定されていない<br />
                                            ・Instagram IDとアクセストークンが正しくない<br />
                                        </div>}
                                        {instagramState && <>
                                            <p className="p-2">
                                                画像は最初の一枚のみWechatに追加可能です。Videoの情報は表示されません
                                            </p>
                                            <div className="m-h-1000">
                                                {instagramDatas?.map((instagramData: IInstagramrData, index: number) => {
                                                    return (
                                                        <div key={`instagramPost-${index}`}>
                                                            <Card className="w-100 mb-3">
                                                                <Card.Body>
                                                                    <div>
                                                                        {instagramData.media_url && <img src={instagramData.media_url} className="w-100" alt="Media" />}
                                                                    </div>
                                                                    <div className="px-1 my-2">
                                                                        {instagramData.caption}
                                                                    </div>
                                                                    <hr />
                                                                    <div>
                                                                        <Button onClick={handleInstagramWechat} data-id={instagramData.id} className="m-1 btn-sm">
                                                                            <span>←Wechatに追加</span>
                                                                        </Button>
                                                                    </div>
                                                                </Card.Body>
                                                            </Card>
                                                        </div>
                                                    )
                                                })}
                                                {moreInstagramLoaded && <div className="w-100 text-center">
                                                    <Spinner animation="border" variant="danger" />
                                                </div>}
                                                {!moreInstagramLoaded && <>
                                                    {instagramNextToken && <div><Button onClick={handleInstagramNext}>
                                                        <span>Next</span>
                                                    </Button></div>}
                                                </>}
                                            </div>
                                        </>}
                                    </>}
                                </div>
                            </Row>
                        </div>
                    </Row>
                </Container >
            </div >
        </>
    )
}

const Wechat = (props: any) => {
    const handleWechat = () => {
        props.setModalType("wechat")
        props.setFormModalShow(true)
    }

    return (
        <>
            <Card>
                <Card.Header className="h3 d-flex align-items-center"><BsFillChatFill className="mr-2" />WeChat 連携</Card.Header>
                {props.wechatState && <>
                    <div className="text-center mt-4">
                        <span className="font-italic h5">{props.wechatState.appId}</span> と連携中
                    </div>
                </>}
                <Card.Body>
                    <Button
                        className="btn-primary"
                        onClick={handleWechat}
                        block>連携</Button>
                </Card.Body>
            </Card>
        </>
    )
}

const Twitter = (props: any) => {
    const handleWechat = () => {
        props.setModalType("twitter")
        props.setFormModalShow(true)
    }

    return (
        <>
            <Card>
                <Card.Header className="h3 d-flex align-items-center">X(Twitter) 連携</Card.Header>
                {props.twitterState && <>
                    <div className="text-center mt-4">
                        <span className="font-italic h5">{props.twitterState.appName && "@" + props.twitterState.appName}</span> と連携中
                    </div>
                </>}
                <Card.Body>
                    <Button
                        className="btn-primary"
                        onClick={handleWechat}
                        block>連携</Button>
                </Card.Body>
            </Card>
        </>
    )
}

const Instagram = (props: any) => {
    const handleWechat = () => {
        props.setModalType("instagram")
        props.setFormModalShow(true)
    }

    return (
        <>
            <Card>
                <Card.Header className="h3 d-flex align-items-center"><BsInstagram className="mr-2" />Instagram連携</Card.Header>
                {props.instagramState && <>
                    <div className="text-center mt-4">
                        <span className="font-italic h5">{props.instagramState.id}</span> と連携中
                    </div>
                </>}
                <Card.Body>
                    <Button
                        className="btn-primary"
                        onClick={handleWechat}
                        block>連携</Button>
                </Card.Body>
            </Card>
        </>
    )
}